// extracted by mini-css-extract-plugin
export default {"layout":"TerritoryLayout_layout__QDzKL","content":"TerritoryLayout_content__zt003"};